import { createFileRoute } from "@tanstack/react-router"
import { useState } from "react"
import {
	ForgotPasswordForm,
	ForgotPasswordSubmitted,
} from "@/components/pages/auth/forgot-password"
import { useForgotPassword } from "@/hooks/mutations/auth"
import type { ForgotPasswordInput } from "@/lib/schemas/auth"

export const Route = createFileRoute("/_auth/forgot-password")({
	validateSearch: (search: Record<string, unknown>): { email?: string } => ({
		email: typeof search.email === "string" ? search.email : undefined,
	}),
	component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
	const { email: initialEmail } = Route.useSearch()
	const [submittedEmail, setSubmittedEmail] = useState<string | null>(null)
	const forgotPassword = useForgotPassword()

	const handleSubmit = ({ email }: ForgotPasswordInput) => {
		forgotPassword.mutate(email, {
			onSuccess: () => {
				setSubmittedEmail(email)
			},
		})
	}

	if (submittedEmail) {
		return <ForgotPasswordSubmitted email={submittedEmail} />
	}

	return (
		<ForgotPasswordForm
			initialEmail={initialEmail ?? ""}
			isSubmitting={forgotPassword.isPending}
			hasError={Boolean(forgotPassword.error)}
			onSubmit={handleSubmit}
		/>
	)
}
